import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Ticker = () => {
    const [messages, setMessages] = useState([]);
    const [speed, setSpeed] = useState(30);

    const fetchMessages = useCallback(async () => {
        try {
            const response = await axios.get(`${API}/ticker-messages/active`);
            setMessages(response.data.map(m => m.message));
        } catch (error) {
            console.error('Failed to fetch ticker messages:', error);
            setMessages([
                "SIGNAL INTERCEPT — STANTON SYSTEM — \"WOLVES ON THE HUNT. ALL PILOTS REPORT TO HANGARS.\"",
                "COMMS RELAY — PYRO GATE ALPHA — \"126TH CSG CONVOY CLEARED FOR TRANSIT. GODSPEED.\"",
                "ENCRYPTED — FREQ 7.126 — \"THE VOID PROVIDES. THE PACK ENDURES.\"",
            ]);
        }
    }, []);

    const fetchSettings = useCallback(async () => {
        try {
            const response = await axios.get(`${API}/ticker-settings`);
            setSpeed(response.data.speed || 30);
        } catch (error) {
            console.error('Failed to fetch ticker settings:', error);
        }
    }, []);

    useEffect(() => {
        // Initial fetch
        fetchMessages();
        fetchSettings();

        // Poll for updates every 10 seconds to keep all viewers synced
        const messagesInterval = setInterval(fetchMessages, 30000); // Messages every 30s
        const settingsInterval = setInterval(fetchSettings, 10000); // Speed every 10s for faster sync

        return () => {
            clearInterval(messagesInterval);
            clearInterval(settingsInterval);
        };
    }, [fetchMessages, fetchSettings]);

    if (messages.length === 0) return null;

    const tickerContent = messages.join(" /// ");

    return (
        <div className="w-full bg-red-900/20 border-y border-red-500/20 py-2 overflow-hidden" data-testid="ticker">
            <div 
                className="ticker-track"
                style={{
                    animationDuration: `${speed}s`
                }}
            >
                <span className="ticker-content font-mono text-xs uppercase tracking-[0.2em] text-red-500">
                    /// {tickerContent} ///&nbsp;&nbsp;&nbsp;
                </span>
                <span className="ticker-content font-mono text-xs uppercase tracking-[0.2em] text-red-500">
                    /// {tickerContent} ///&nbsp;&nbsp;&nbsp;
                </span>
            </div>
        </div>
    );
};
